import script from "./ShipToList.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipToList.vue?vue&type=script&setup=true&lang=js"

import "./ShipToList.vue?vue&type=style&index=0&id=6f920bce&lang=scss"

const __exports__ = script;

export default __exports__